import { render, staticRenderFns } from "./EquipItem.vue?vue&type=template&id=e85bbac6&"
import script from "./EquipItem.vue?vue&type=script&lang=js&"
export * from "./EquipItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports